/* eslint-disable @typescript-eslint/no-unused-vars */
import { datadogLogs } from '@datadog/browser-logs';
import { matchRoutes } from 'react-router-dom';
import { auth } from 'utils/auth';
import { getStoreAdmin, getMyInfo } from './storages';

export const setUser = () => {
  if (!process.env.NODE_ENV) return;

  const accessToken = auth.getAccessToken();
  const storeAdminInfo = getStoreAdmin();
  const myInfo = getMyInfo();

  if (accessToken) {
    datadogLogs.setUser({
      id: myInfo?.id,
      accessToken,
      storeAdminSaid: storeAdminInfo?.said
    });
  }
};

export const datadogLogsInit = () => {
  if (!process.env.NODE_ENV) return;
  datadogLogs.init({
    clientToken: 'pub55faeecd38aa70fcbf4e4876e3fa12f2',
    service: process.env.NODE_ENV === 'development' ? 'develop-store-web' : 'production-store-web',
    site: 'datadoghq.com',
    env: process.env.NODE_ENV === 'development' ? 'develop' : 'production',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    beforeSend: (log) => {
      if (log.message) {
        const includes = ['antd: Modal', 'useForm', 'findDOMNode', '[GetSapElementFromHtmlId]'];
        if (includes.some((include) => log.message.includes(include))) {
          return false;
        }
      }
      return true;
    }
  });
};

type PathMapType = {
  path: string;
  key: string;
  screen: string;
};

export const pathMap: PathMapType[] = [
  { path: '/', screen: '홈', key: 'HOME' },
  { path: 'menuManage', screen: '메뉴 관리', key: 'MENU_MANAGE' }
];

export const getAppRouteOrder = () => matchRoutes(pathMap, window.location.pathname)?.pop()?.route as PathMapType;

export const { logger } = datadogLogs;

export const infoLogger = (message: string, messageContext?: unknown) => {
  if (!process.env.NODE_ENV) return;
  const { key, screen } = getAppRouteOrder() || {};
  const logData = { 'ui-key': key, 'ui-screen': screen, 'log-version': '0.0.1' };
  datadogLogs.logger.info(message, { ...(messageContext as object), ...logData });
};

export const errorLogger = (message: string, messageContext?: unknown, error?: Error) => {
  if (!process.env.NODE_ENV) return;
  const { key, screen } = getAppRouteOrder() || {};
  const logData = { 'ui-key': key, 'ui-screen': screen, 'log-version': '0.0.1' };
  datadogLogs.logger.error(message, { ...(messageContext as object), ...logData }, error);
};

export const eventLogger = (message: string, messageContext?: unknown) => {
  if (!process.env.NODE_ENV) return;
  const { key, screen } = getAppRouteOrder() || {};
  const logData = { 'ui-key': key, 'ui-screen': screen, 'log-version': '0.0.1' };
  datadogLogs.logger.info(message, { ...(messageContext as object), ...logData, 'ui-metric': true });
};
